import { Product } from '../../../stores/appReportsStore'
import { Platform } from '../../../types/Platforms'
import { ProductAggregation } from '../../orderhistory/types'
import { SourcingRequestItem } from '../../../services/sourcing/sourcingOptionsService'

/** Maps an order-history product aggregation to the shared Product shape used by sourcing/compare. */
export function aggregationToProduct(agg: ProductAggregation): Product {
  const stdUnit = agg.quantityInfo?.stdUnit || agg.unitPrice?.unit || 'piece'
  const stdAmount = agg.quantityInfo?.stdAmount || 1
  const stdMultiplier = agg.quantityInfo?.stdMultiplier || 1
  const standardizedAmount = stdAmount * stdMultiplier

  let unitPriceUnit = 'piece'
  const unitLower = stdUnit.toLowerCase()
  if (unitLower === 'g' || unitLower === 'gram') unitPriceUnit = 'kg'
  else if (unitLower === 'ml' || unitLower === 'milliliter') unitPriceUnit = 'l'

  return {
    platform: Platform.fromString(agg.platform),
    category: agg.category || '',
    name: agg.name,
    brand: '',
    articleId: agg.articleId,
    src: '',
    link: '',
    matchScore: 100,
    price: agg.price || 0,
    isKiloPrice: unitLower === 'g' || unitLower === 'ml',
    unitPrice: agg.unitPrice?.value || 0,
    unitPriceUnit,
    quantity: agg.qty || 1,
    useSingle: true,
    useCombo: false,
    standardUnit: stdUnit,
    standardizedAmount,
    estimatedWeightPerPiece: 0,
    hasComboOption: false,
    combo: undefined,
  }
}

/** Builds the request payload (one item per product) sent to the compare endpoint. */
export function buildCompareItems(products: ProductAggregation[]): SourcingRequestItem[] {
  return products.map(agg => {
    const p = aggregationToProduct(agg)
    return {
      articleId: p.articleId,
      category: p.category,
      mainCategory: agg.mainCategory || '',
      productLink: p.link,
      platform: p.platform.toString(),
      name: p.name,
      quantity: p.quantity,
      unitPrice: p.unitPrice,
      unitPriceUnit: p.unitPriceUnit,
      standardizedAmount: p.standardizedAmount,
      standardUnit: p.standardUnit,
    }
  })
}

/** Savings fraction from UNIT PRICE (positive = cheaper). 0 when units differ or a price is missing. */
export function unitPriceSavingsFraction(parent: Product, option?: Product): number {
  if (!option || option.articleId === parent.articleId) return 0
  if (option.unitPriceUnit.toLowerCase() !== parent.unitPriceUnit.toLowerCase()) return 0
  if (parent.unitPrice <= 0 || option.unitPrice <= 0) return 0
  return (parent.unitPrice - option.unitPrice) / parent.unitPrice
}

export function formatUnitPrice(product: Product): string {
  if (!product.unitPrice || product.unitPrice === 0) return '--'
  return `€${product.unitPrice.toFixed(2)}/${product.unitPriceUnit}`
}
